// extracted by mini-css-extract-plugin
export default {"modal__background":"Modal_modal__background__pT-nQ","modal__content":"Modal_modal__content__gsNaK"};